// extracted by mini-css-extract-plugin
export var block = "main-menu-module--block--16g5m";
export var menuItem = "main-menu-module--menuItem--Auoy2";
export var menuLink = "main-menu-module--menuLink--1N9F9";
export var activeTrail = "main-menu-module--activeTrail--1mXda";
export var zzz = "main-menu-module--zzz--2PujD";
export var active = "main-menu-module--active--2f_3a";